import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory, StringPropertyEditor, BooleanPropertyEditor } from "adaptivecards-designer";
import { removeOtherPropertyConfigurations } from "./Utils/CustomElementUtils";

const displayLabelProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "displayLabel", true);
const mapTextProperty = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "mapText");
const visibleFieldProperty = new Adaptive.BoolProperty(Adaptive.Versions.v1_0, "visibleField");
const contentFieldProperty = new Adaptive.StringProperty(Adaptive.Versions.v1_0, "contentField", false);

export class RequestTitle extends Adaptive.TextInput {
    static readonly JsonTypeName = "Request";
    static readonly ElementId = "Ticket.Request";
    static readonly defaultLabel = "Request";
    static readonly displayLabelProperty = displayLabelProperty;
    static readonly mapTextProperty = mapTextProperty;
    static readonly visibleFieldProperty = visibleFieldProperty;
    static readonly contentFieldProperty = contentFieldProperty;

    //#region Schema

    @Adaptive.property(displayLabelProperty)
    get displayLabel(): string | undefined {
        return this.getValue(RequestTitle.displayLabelProperty);
    }

    set displayLabel(value: string | undefined) {
        this.setValue(RequestTitle.displayLabelProperty, value);
        this.updateLayout();
    }


    @Adaptive.property(displayLabelProperty)
    get mapText(): boolean | undefined {
        return this.getValue(RequestTitle.mapTextProperty);
    }

    set mapText(value: boolean | undefined) {
        this.setValue(RequestTitle.mapTextProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(visibleFieldProperty)
    get visibleField(): boolean | undefined {
        return this.getValue(RequestTitle.visibleFieldProperty);
    }

    set visibleField(value: boolean | undefined) {
        this.setValue(RequestTitle.visibleFieldProperty, value);
        this.updateLayout();
    }

    @Adaptive.property(contentFieldProperty)
    get contentField(): string | undefined {
        return this.getValue(RequestTitle.contentFieldProperty);
    }

    set contentField(value: string | undefined) {
        this.setValue(RequestTitle.contentFieldProperty, value);
        this.updateLayout();
    }

    //#endregion

    protected internalRender(): HTMLElement | undefined {
        this.id = RequestTitle.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = RequestTitle.defaultLabel;
        if(this?.visibleField == undefined)
            this.visibleField = true;
        if(this?.contentField == undefined)
            this.contentField = "{{message}}";

        let textInput = new Adaptive.TextInput();
        textInput.setParent(this);
        textInput.label = this.displayLabel;
        textInput.isRequired = true;
        textInput.isMultiline = true;

        if(this.defaultValue)
            textInput.defaultValue = this.defaultValue;

        const renderedElement =  textInput.render();
        this.inputControlContainerElement.style.display = "block";

        return renderedElement;
    }

    getJsonTypeName(): string {
        return RequestTitle.JsonTypeName;
    }

    updateLayout(processChildren: boolean = true) {
        super.updateLayout(processChildren);
    }
}

export class RequestTitlePeer extends TypedCardElementPeer<RequestTitle> {
    static readonly displayLabelProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "displayLabel", "Label", false);
    static readonly visibleFieldProperty = new BooleanPropertyEditor(Adaptive.Versions.v1_0, "visibleField", "Initially visible", false);
    static readonly contentFieldProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "contentField", "Request", false, true);

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);

        propertySheet.add(
            defaultCategory,
            RequestTitlePeer.idProperty,
            RequestTitlePeer.displayLabelProperty,
            RequestTitlePeer.visibleFieldProperty,
            RequestTitlePeer.contentFieldProperty
        );
    }
}